export default {
    liquiditaet: {
        Question1: {
            age: 0,
            isAnswered: false,
        },
        Question2: {
            value: '',
            isAnswered: false,
            autoRedirect: true,
            condition: (state) => {
                return state.Question1.age >= 18 && state.Question1.age <= 26;
            },
        },
        Question3a: {
            value: '',
            isAnswered: false,
            condition: (state) => {
                return state.Question1.age >= 27 || (state.Question1.age < 27 && state.Question2.value === 'no');
            },
        },
        Question3b: {
            value: '',
            isAnswered: false,
            hideFromNavigation: true,
        },
        Question3c: {
            value: '',
            isAnswered: false,
            hideFromNavigation: true,
        },
        Question4: {
            value: '',
            isAnswered: false,
            autoRedirect: true,
        },
        Question5: {
            value: '',
            isAnswered: false,
            autoRedirect: true,
        },
        Question6a: {
            value: '',
            isAnswered: false,
            condition: (state) => {
                return state.Question1.age >= 18 && state.Question5.value === 'yes';
            },
        },
        Question6b: {
            value: '',
            isAnswered: false,
            hideFromNavigation: true,
            condition: (state) => {
                return state.Question1.age >= 18;
            },
        },
        Question7: {
            value: '',
            isAnswered: false,
            autoRedirect: true,
            condition: (state) => {
                return state.Question1.age >= 18;
            },
        },
        Question8: {
            value: '',
            isAnswered: false,
            autoRedirect: true,
        },
    },
    absicherung: {
        Question1: {
            age: 0,
            isAnswered: false,
        },
        Question2: {
            family_status: '',
            isAnswered: false,
            autoRedirect: true,
            condition: (state) => {
                return state.Question1.age >= 18 && state.Question1.age <= 50;
            },
        },
        Question3: {
            children: '',
            isAnswered: false,
            autoRedirect: true,
            condition: (state) => {
                return state.Question1.age >= 18 && state.Question1.age <= 50;
            },
        },
        Question4: {
            job: '',
            isAnswered: false,
            autoRedirect: true,
            condition: (state) => {
                return state.Question1.age >= 18 && state.Question1.age <= 45;
            },
        },
        Question5a: {
            value: '',
            isAnswered: false,
            condition: (state) => {
                return state.Question1.age >= 18;
            },
        },
        Question5b: {
            value: '',
            isAnswered: false,
            hideFromNavigation: true,
        },
        Question6: {
            value: '',
            isAnswered: false,
            autoRedirect: true,
            condition: (state) => {
                return state.Question1.age >= 18;
            },
        },
        Question7: {
            car: '',
            isAnswered: false,
            autoRedirect: true,
        },
        Question8: {
            value: '',
            isAnswered: false,
            autoRedirect: true,
        },
    },
    vermoegen: {
        Question1: {
            liquidity: 0,
            isAnswered: false,
        },
        Question2: {
            income: 0,
            liquidityBuffer: 0,
            isAnswered: false,
        },
        QuestionCalculateCashReserve: {
            isAnswered: false,
            cash_reserve_gap_is_positive: false,
            cash_reserve_gap: 0,
        },
        QuestionCalculateSecurities: {
            custom_investment_amount: 5000,
            custom_investment_duration: 10,
            custom_return_call_money: 0,
            custom_return: 0.04,
            isAnswered: false,
        },
        Question3: {
            reserve: 50,
            custom_investment_amount: 10000,
            custom_investment_duration: 10,
            custom_return_call_money: 0,
            custom_return: 0.04,
            isAnswered: false,
        },
        Question4: {
            risk_profile: 1,
            isAnswered: false,
        },
        Question5: {
            consulting: '',
            isAnswered: false,
            autoRedirect: true,
            condition: (state) => {
                return state.Question4.risk_profile !== 0;
            },
        },
        Question6: {
            value: '',
            isAnswered: false,
            condition: (state) => {
                return state.Question4.risk_profile !== 0;
            },
        },
    },
    vorsorge: {
        Question1: {
            age: 0,
            isAnswered: false,
        },
        Question2: {
            property: '',
            isAnswered: false,
            autoRedirect: true,
            condition: (state) => {
                return state.Question1.age >= 18;
            },
        },
        Question3a: {
            renovation: '',
            isAnswered: false,
            condition: (state) => {
                return state.Question2.property === 'yes';
            },
        },
        Question3b: {
            renovation_timing: '',
            isAnswered: false,
            hideFromNavigation: true,
        },
        Question4a: {
            property: '',
            isAnswered: false,
            condition: (state) => {
                return state.Question2.property === 'no';
            },
        },
        Question4b: {
            property_timing: '',
            isAnswered: false,
            hideFromNavigation: true,
        },
        Question5: {
            job: '',
            isAnswered: false,
            autoRedirect: true,
        },
        Question6: {
            employed_partner: '',
            isAnswered: false,
            autoRedirect: true,
            condition: (state) => {
                return parseInt(state.Question5.job) === 6;
            },
        },
        Question7: {
            value: '',
            isAnswered: false,
            autoRedirect: true,
            condition: (state) => {
                return state.Question1.age >= 18 && state.Question1.age <= 50;
            },
        },
    },
};
